import { SET_APP_CONFIG } from '../Types';

export const setAppConfig = (payload) => ({ type: SET_APP_CONFIG, payload });
